import { createSlice } from '@reduxjs/toolkit';
import { TimeStampTopic } from 'src/lib/hooks/video-player/useTimeStampTopic';

interface TimeStampState {
  activeTimestampTopicId: string;
  openTimestampReportId: string;
  timeStampReportId: string;
  activeTimestampTopicDetails: TimeStampTopic;
  timestampTopicList: TimeStampTopic[];
  playerTotalDuration: number;
  playerCurrentTime: number;
  playerBufferedDuration: number;
  isSubTopicSelectFromSidebar: boolean;
  isSubtoipcTimestampFeatureEnabled: boolean;
}

const initialState: TimeStampState = {
  activeTimestampTopicDetails: { ...new TimeStampTopic({}) },
  activeTimestampTopicId: '',
  timestampTopicList: [],
  openTimestampReportId: '',
  timeStampReportId: '',
  playerTotalDuration: 0,
  playerCurrentTime: 0,
  playerBufferedDuration: 0,
  isSubTopicSelectFromSidebar: false,
  isSubtoipcTimestampFeatureEnabled: false,
};

export const timestampSlice = createSlice({
  name: 'timestamp',
  initialState,
  reducers: {
    updateOpenReportId: (state: TimeStampState, action) => {
      state.openTimestampReportId = action.payload;
      if (action.payload !== '') {
        state.timeStampReportId = action.payload;
      }
    },
    updateActiveTimestampTopicDetails: (state: TimeStampState, action) => {
      // updating active timestamp topic details
      const newPlayload = { ...action.payload };
      if (newPlayload?.isSubTopicSelectFromSidebar) {
        state.isSubTopicSelectFromSidebar = newPlayload?.isSubTopicSelectFromSidebar;
        delete newPlayload?.isSubTopicSelectFromSidebar;
      }
      state.activeTimestampTopicDetails = { ...action.payload };
      state.activeTimestampTopicId = action.payload._id;
    },
    updateTimeStampTopicList: (state: TimeStampState, action) => {
      // updating active timestamp topic list
      state.isSubtoipcTimestampFeatureEnabled = action.payload?.length > 0;
      state.timestampTopicList = action.payload;
    },
    updateCurrentTimeStamp: (state: TimeStampState, action) => {
      const currentTime = action.payload?.currentTime || '';
      const currentTimeNumber = Math.floor(currentTime) || 0;
      state.playerCurrentTime = currentTimeNumber;
      const currentTimestampTitle = state.timestampTopicList.find(
        (item) => item.startTimeDuration <= currentTime && item.endTimeDuration > currentTime,
      );
      if (currentTimestampTitle) {
        state.activeTimestampTopicDetails = currentTimestampTitle;
        state.activeTimestampTopicId = currentTimestampTitle._id;
      }
    },
    updatePlayerTotalDuration: (state: TimeStampState, action) => {
      state.playerTotalDuration = action.payload;
    },
    udpateIsSubtopicSelectFromSidebar: (state: TimeStampState, action) => {
      state.isSubTopicSelectFromSidebar = action.payload;
    },
    updateBufferedDuration: (state: TimeStampState, action) => {
      state.playerBufferedDuration = action.payload;
    },
  },
});

export const {
  updateOpenReportId,
  updateActiveTimestampTopicDetails,
  updateTimeStampTopicList,
  updateCurrentTimeStamp,
  updatePlayerTotalDuration,
  udpateIsSubtopicSelectFromSidebar,
  updateBufferedDuration,
} = timestampSlice.actions;
